import { api, guard, unwrap } from './client'

export const metricsApi = {
  overview: (hours: number) =>
    guard(async () => unwrap(await api.GET('/api/metrics/overview', { params: { query: { hours } } }))),

  tools: (hours: number) =>
    guard(async () => unwrap(await api.GET('/api/metrics/tools', { params: { query: { hours } } }))),

  errors: (hours: number) =>
    guard(async () => unwrap(await api.GET('/api/metrics/errors', { params: { query: { hours } } }))),
}
